import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { useDynamicAssetFolder } from 'utils/assets';
import s from 'components/shared/playlist/playlistItem.sss';
import HTML from 'components/core/html/html.js';

export default class PlaylistItem extends Component {

	constructor() {
		super();
		this.previousHeight = 0;
		this.selectWithKeyDown = this.selectWithKeyDown.bind(this);
	}

	scrollToMe() {
		if (!this.base) return;
		const $scrollBox = this.base.parentElement.parentElement;
		smoothScrollTo($scrollBox, this.base, 300, { horizontal: true, relativeTo: '50%' });
	}

	componentDidMount() {
		if (this.props.active) {
			this.scrollToMe();
		}
	}

	componentDidUpdate(old) {
		// if (this.thumb) {
		// 	let height = this.thumb.offsetHeight;
		// 	if (height !== this.previousHeight) {
		// 		this.previousHeight = height;
		// 		this.thumb.style.height = height + 'px';
		// 		setTimeout(() => this.thumb.style.height = '', 50);
		// 	}
		// }
		if (!old.active && this.props.active) {
			this.scrollToMe();
		}
	}

	selectWithKeyDown(e) {
		if (e.key === 'Enter') {
			this.props.onSelect(this.props.item, e);
		}
	}

	render(props) {
		const {
			active,
			item,
			onSelect,
			copy = {},
			playlistId = '',
			isOpen
		} = props;

		const getValue = str => str && (copy[str] || (str.charAt(0) !== '$' ? str : ''));

		const name = getValue(item.name);
		const galleryAlt = props.alt;
		const alt = getValue(item.alt || item.name) || galleryAlt;

		return (
			<li
				class={joinClasses(active ? s.thumbWrapperActive : s.thumbWrapper, s[playlistId + 'Container'], isOpen && s.isOpen)}
				onClick={onSelect.bind(this, item)}
				ref={$ref => this.$item = $ref}
				key={this.$item}
				role="button"
				tabindex="0"
				onKeyDown={this.selectWithKeyDown}
			>
				<img
					class={active ? s.active : s.thumb}
					src={useDynamicAssetFolder(item.thumbSrc)}
					alt={alt}
					ref={thumb => (this.thumb = thumb)}
				/>
				<div class={s.overlay} key="overlay">
					{name && <HTML tag="h3" content={name} markdown />}
				</div>
			</li>
		);
	}

}
